import React from "react"
import { useDispatch, useSelector } from "react-redux";
import { componentKey, removeNotification } from "./ToasterPortalSlice";
import TxToast from "../../components/toast/TxToast";
import ReactDOM from "react-dom"
import styles from "./ToasterPortal.styles"

const ToastPortal = () => {

    const { notifications } = useSelector((state) => state[componentKey]);
    const dispatch = useDispatch();

    return ReactDOM.createPortal(
        <div style={styles.toastContainer}>
            <div style={styles.positionAbsolute}>
                {
                    notifications.map((n, idx) => (
                        n?.message && n.message !== "" ? (
                            <TxToast
                                key={`toaster-${idx}`}
                                heading={n.heading}
                                message={n.message}
                                variant={n.variant}
                                onCloseCb={() => dispatch(removeNotification(idx))}
                            />
                        ) : (
                            dispatch(removeNotification(idx))
                        )
                    ))
                }
            </div>
        </div>,
        document.getElementById('app-toasts')
    );
};

export default ToastPortal;